export const TRACKING_ELEMENTS = {
    googleLoginButton: 'GoogleLoginButton',
    facebookLoginButton: 'FacebookLoginButton',
    appleLoginButton: 'AppleLoginButton',
    signUpLink: 'SignUpLink',
};
